import { render, staticRenderFns } from "./CalculatedPrice.vue?vue&type=template&id=6ba2effc&scoped=true&"
import script from "./CalculatedPrice.vue?vue&type=script&lang=js&"
export * from "./CalculatedPrice.vue?vue&type=script&lang=js&"
import style0 from "./CalculatedPrice.vue?vue&type=style&index=0&id=6ba2effc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba2effc",
  null
  
)

export default component.exports